import {inject, injectable} from "inversify";
import {DivisionPromotion, KODivision} from "@/modules/competitions/entity";
import {Season} from "@/modules/season/entity";
import {CupCompetition} from "@/modules/competitions/entity/CupCompetition";
import CupCompetitionMatchdayGenerator from "@/modules/competitions/services/divisions/CupCompetitionMatchdayGenerator";
import {PromotionIconEnum} from "@/modules/competitions/enums";

@injectable()
export default class CupCompetitionFactory {
  constructor(
    @inject(CupCompetitionMatchdayGenerator) private cupCompetitionMatchdayGenerator: CupCompetitionMatchdayGenerator
  ) {}

  async generate(season: Season, name: string, rounds: number, homeAndAway: boolean, homeAndAwayFinal = false): Promise<CupCompetition> {
    const competition = new CupCompetition();
    competition.name = name;
    competition.rounds = rounds;
    competition.homeAndAway = homeAndAway;
    competition.homeAndAwayFinal = homeAndAwayFinal;
    await competition.save();
    console.debug(`generated competition: ${name}.`);

    let prevDivision: KODivision | undefined = undefined;

    for (let round = rounds; round >= 1; round--) {
      const division = new KODivision();

      const roundNames = [
        translator.t('finals'),
        translator.t('semifinals'),
        translator.t('quarterfinals'),
      ];

      division.prev = prevDivision;
      division.round = round;
      division.name = roundNames[round - 1] || `${round}. round`;
      division.competition = competition;
      await division.save();
      console.debug('generated division: ' + division.name);

      if (round === 1) {
        const divisionPromotion = new DivisionPromotion();
        divisionPromotion.division = division;
        divisionPromotion.price = 7500;
        divisionPromotion.icon = PromotionIconEnum.CUP;
        divisionPromotion.endOfTheSeason = true;
        await divisionPromotion.save();
      }

      if (prevDivision) {
        const divisionPromotion = new DivisionPromotion();
        divisionPromotion.division = prevDivision;
        divisionPromotion.target_division = division;
        await divisionPromotion.save();
      }

      prevDivision = division;
    }

    await this.cupCompetitionMatchdayGenerator.generate(season, competition);

    return competition;
  }
}
